import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

const useFinancialYearStore = create(
  devtools(
    persist(
      (set, get) => ({
        // Financial year data
        currentFinancialYear: null,
        
        // Actions
        setCurrentFinancialYear: (financialYear) =>
          set(
            { currentFinancialYear: financialYear },
            false,
            'set-current-financial-year'
          ),
        
        getCurrentFinancialYear: () => get().currentFinancialYear,
        
        // Clear financial year data
        clearFinancialYear: () =>
          set(
            { currentFinancialYear: null },
            false,
            'clear-financial-year'
          ),
        
        // Utility getters
        getFys: () => get().currentFinancialYear?.fys || null,
        getFye: () => get().currentFinancialYear?.fye || null,
        getFyId: () => get().currentFinancialYear?.fy_id || get().currentFinancialYear?.srno || null,
      }),
      {
        name: 'financial-year-storage',
        partialize: (state) => ({ 
          currentFinancialYear: state.currentFinancialYear 
        }), // Only persist financial year data
      }
    ),
    {
      name: 'financial-year-store', // Name for devtools
    }
  )
);

export default useFinancialYearStore; 